import React, { useEffect, useState } from 'react'
import CrmEmpty from "./CrmEmpty";
import { Table, Spin, Pagination } from 'antd';
import moment from 'moment-jalaali';
import strings from "../../../utils/strings";
import { useReportsStore } from '../../../store/slices/createReportsSlice';
import { useGeneralStore } from "../../../store/slices/createGeneralSlice";

export default function CrmSmsReport({ usrUserID, pageSize, category }) {



    const reports = useReportsStore()
    const general = useGeneralStore();
    const smsDetails = reports.crmSmsReport.data.Items;
    const total = reports.crmSmsReport.data.Total;
    const visible = general.view.crmReportModal;
    const loading = reports.crmSmsReport.loading;
    const [page, setPage] = useState(1);



    const pageChange = (page, pageSize) => {

        setPage(page)
        reports.getCrmSmsReport({
            usrUserID: usrUserID,
            PageSize: pageSize,
            PageNumber: page
        });

    }


    useEffect(() => {
        setPage(1)

        if (usrUserID || category === "Sms" || visible) {
            setPage(1)

        }

    }, [usrUserID, category, visible])



    const columns = [
        {
            title: "موضوع",
            dataIndex: "SubjectTitle",
            width: 90,
            key: "SubjectTitle",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "کاربر ارسال کننده",
            dataIndex: "SenderFullName",
            width: 70,
            key: "SenderFullName",
            render: text => <span>{text ? text : "-"}</span>,
        },
        {
            title: "تاریخ ارسال",
            dataIndex: "SendDate",
            key: "SendDate",
            width: 70,
            render: data => strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm  "))
        },
        {
            title: "متن پیام",
              width: 110,
            dataIndex: "Text",
            key: "Text",
            width: 300,
        },
    ];
    return (
        <Spin spinning={loading}>
            {smsDetails && smsDetails.length > 0 ?
                <>
                    <Table
                        style={{ overflowX: 'scroll' }}
                        size="small"
                        className="custom-table crm-request-report"
                        bordered
                        loading={loading}
                        rowKey="ID"
                        scroll={true}
                        dataSource={smsDetails}
                        columns={columns}
                        pagination={false}
                    />
                    <Pagination
                        defaultCurrent={1}
                        current={page}
                        onChange={pageChange}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger={false} />
                </>
                :
                <CrmEmpty text="پیامک یافت نشد" />}
        </Spin>

    )
}